<template>
	<div class="flex justify-start items-center ml-4 mt-4 md:ml-0 md:mt-0">
		<button
			@click="showDropdown = !showDropdown"
			class="
				text-gray-700 text-2xl
				outline-none
				focus:outline-none
				flex
				items-center
			"
		>
			<RoundImage
				heightWeight="w-8 h-8 md:w-8 md:h-8"
				imageStyle="shadow-md rounded-full border-2 border-gray-100"
				:image="user?.profile?.photo"
			/>
        <div class="flex flex-col justify-items-start items-start mx-2">
            <p class="text-xs px-1 text-gray-600 font-bold">{{ user?.name.split(" ")[0] }}</p>
            <p class="text-xs px-1 text-gray-400">{{ user?.phone }}</p>
        </div>

			<svg
				:class="[showDropdown ? 'opened' : 'closed']"
				xmlns="http://www.w3.org/2000/svg"
				width="20"
				height="20"
				viewBox="0 0 24 24"
				fill="none"
				stroke="currentColor"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round"
				class="feather feather-chevron-down"
			>
				<polyline points="6 9 12 15 18 9"></polyline>
			</svg>
		</button>

		<div
			class="
				md:hidden
				origin-top-right
				top-14
				left-3
				md:top-10 md:left-auto
				absolute
				z-50
				md:right-0
				mt-2
				w-56
				rounded-md
				shadow-lg
				bg-white
				ring-1 ring-black ring-opacity-5
			"
		>
			<div
				class="py-1"
				role="menu"
				aria-orientation="vertical"
				aria-labelledby="options-menu"
			>
				<p
					class="cursor-pointer block capitalize px-4 py-2 hover:bg-gray-100"
					@click="
						logOut();
						$emit('onClickAccountDropdown');
					"
				>
					<span
						class="text-sm text-gray-700 hover:text-gray-900"
						v-if="!isLoggingOut"
						>Log Out</span
					>
					<span class="text-sm text-gray-700 hover:text-gray-900" v-else
						>Logging Out</span
					>
				</p>
			</div>
		</div>

		<div
			v-if="showDropdown"
			class="
				hidden
				md:block
				origin-top-right
				top-14
				left-3
				md:top-10 md:left-auto
				absolute
				z-50
				md:right-0
				mt-2
				w-56
				rounded-md
				shadow-lg
				bg-white
				ring-1 ring-black ring-opacity-5
			"
		>
			<div
				class="py-1"
				role="menu"
				aria-orientation="vertical"
				aria-labelledby="options-menu"
			>
<!--				<template v-for="(item, i) in links">
					<router-link
					    :to="{name: item.link}"
						:key="i"
						@click="
							nevigate();
							$emit('onClickAccountDropdown');
						"
						v-if="userType === item.type"
						class="cursor-pointer block capitalize px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 border-b-1 border-gray-100"
					>
              <span class="mdi mdi-{{ item.icon }} inline-block mr-2"></span>
						{{ item.title }}
					</router-link>
				</template>-->
          <div
              @click="$router.push('/customer/profile'); nevigate(); $emit('onClickAccountDropdown');"
              class="items-center cursor-pointer flex capitalize px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 border-b-1 border-gray-100"
          >
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M7.55556 7.44444C7.55556 6.2657 8.02381 5.13524 8.8573 4.30175C9.6908 3.46825 10.8213 3 12 3C13.1787 3 14.3092 3.46825 15.1427 4.30175C15.9762 5.13524 16.4444 6.2657 16.4444 7.44444C16.4444 8.62318 15.9762 9.75365 15.1427 10.5871C14.3092 11.4206 13.1787 11.8889 12 11.8889C10.8213 11.8889 9.6908 11.4206 8.8573 10.5871C8.02381 9.75365 7.55556 8.62318 7.55556 7.44444ZM7.55556 14.1111C6.08213 14.1111 4.66905 14.6964 3.62718 15.7383C2.58532 16.7802 2 18.1932 2 19.6667C2 20.5507 2.35119 21.3986 2.97631 22.0237C3.60143 22.6488 4.44928 23 5.33333 23H18.6667C19.5507 23 20.3986 22.6488 21.0237 22.0237C21.6488 21.3986 22 20.5507 22 19.6667C22 18.1932 21.4147 16.7802 20.3728 15.7383C19.3309 14.6964 17.9179 14.1111 16.4444 14.1111H7.55556Z" fill="#D71920"/>
              </svg>
              <span class="ml-2">প্রোফাইল</span>
          </div>

          <div
              @click="$router.push('/trips'); nevigate(); $emit('onClickAccountDropdown');"
              class="items-center cursor-pointer flex capitalize px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 border-b-1 border-gray-100"
          >
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                  <path d="M4.22565 6.504L3.86854 4.99697C3.83969 4.87597 3.7873 4.76184 3.71435 4.6611C3.6414 4.56035 3.54933 4.47496 3.44338 4.4098C3.33743 4.34463 3.21968 4.30098 3.09686 4.28132C2.97403 4.26166 2.84854 4.26639 2.72755 4.29523C2.60655 4.32408 2.49242 4.37647 2.39168 4.44942C2.29093 4.52237 2.20554 4.61444 2.14038 4.72039C2.07521 4.82634 2.03156 4.94409 2.0119 5.06691C1.99225 5.18974 1.99697 5.31523 2.02581 5.43622L2.9686 9.33236C3.02789 9.57469 3.18047 9.7838 3.39314 9.91421C3.60581 10.0446 3.86137 10.0858 4.10423 10.0287L8.00394 9.09666C9.23243 8.79669 8.78603 6.95397 7.55755 7.25394L5.68269 7.70748C6.67733 6.45185 8.02326 5.52074 9.54899 5.03281C11.0747 4.54487 12.7112 4.52219 14.2498 4.96767C15.7885 5.41314 17.1597 6.30659 18.1888 7.53419C19.2178 8.76178 19.8581 10.2679 20.0281 11.8607C20.1316 13.1535 22.0886 12.9428 21.9101 11.6572C21.3637 6.53614 17.0069 2.72214 11.4537 2.7757C8.19679 3.09711 5.82911 4.49701 4.22565 6.504ZM15.9819 15.8747C14.7034 16.139 15.1641 18.0639 16.4212 17.7175L18.296 17.2639C17.3037 18.5241 15.9579 19.4595 14.431 19.9505C12.904 20.4415 11.2653 20.4657 9.72444 20.0201C8.18361 19.5745 6.81077 18.6793 5.78157 17.4491C4.75238 16.2189 4.11365 14.7095 3.9471 13.1142C3.94078 12.9854 3.9082 12.8592 3.85136 12.7435C3.79451 12.6277 3.71461 12.5248 3.61654 12.441C3.51847 12.3572 3.40432 12.2944 3.28109 12.2563C3.15786 12.2183 3.02815 12.2058 2.89992 12.2197C2.7717 12.2336 2.64767 12.2736 2.53545 12.3371C2.42323 12.4007 2.32519 12.4865 2.24734 12.5894C2.1695 12.6922 2.11349 12.8099 2.08277 12.9351C2.05204 13.0604 2.04724 13.1906 2.06867 13.3178C2.35288 15.9435 3.66649 18.3494 5.72159 20.0082C7.77668 21.667 10.4056 22.4434 13.0321 22.1671C14.3411 22.0263 15.609 21.6267 16.7622 20.9915C17.9154 20.3564 18.9308 19.4984 19.7495 18.4674L20.1138 19.978C20.3459 21.2993 22.3422 20.8208 21.9493 19.5388L21.0173 15.639C20.9101 15.1891 20.4959 14.882 19.9531 14.9248L15.9819 15.8747Z" fill="#D71920"/>
              </svg>
              <span class="ml-2">চলমান ট্রিপ দেখুন</span>
          </div>

          <div
              @click="$router.push('/contact'); nevigate(); $emit('onClickAccountDropdown');"
              class="items-center cursor-pointer flex capitalize px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 border-b-1 border-gray-100"
          >
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                  <path d="M22.9896 12.8337C23.0247 13.6795 22.7258 14.5048 22.1584 15.1286C21.5911 15.7523 20.8016 16.1236 19.9633 16.1609C19.9142 16.1632 19.8653 16.1644 19.8165 16.1644C19.5937 16.1642 19.3716 16.1399 19.154 16.0918C18.5084 17.0974 17.6618 17.956 16.6684 18.6127C15.675 19.2694 14.5566 19.7096 13.3849 19.9054C13.2463 20.3161 12.9698 20.6651 12.6032 20.8919C12.2366 21.1188 11.803 21.2094 11.3772 21.148C10.9515 21.0865 10.5604 20.8769 10.2715 20.5555C9.98268 20.234 9.81426 19.8208 9.79537 19.3874C9.77648 18.954 9.90831 18.5275 10.1681 18.1817C10.4278 17.8359 10.7992 17.5925 11.218 17.4936C11.6367 17.3947 12.0766 17.4465 12.4615 17.6401C12.8464 17.8337 13.1522 18.1568 13.326 18.5537C14.9756 18.2459 16.4659 17.364 17.5371 16.0615C18.6083 14.7591 19.1924 13.1188 19.1877 11.4265C19.1877 7.42836 15.9633 4.17569 12 4.17569C8.03666 4.17569 4.81228 7.42836 4.81228 11.4265C4.81206 12.6627 5.12527 13.8785 5.72213 14.9583C5.74236 14.9939 5.75754 15.0322 5.76724 15.0721C5.82489 15.2338 5.81873 15.4116 5.75003 15.5688C5.68133 15.7259 5.55535 15.8505 5.39816 15.9166C5.01327 16.08 4.59989 16.1641 4.1823 16.164C4.13316 16.164 4.08391 16.1629 4.03456 16.1606C3.19655 16.1228 2.4076 15.7513 1.84069 15.1276C1.27378 14.5039 0.975193 13.6789 1.01039 12.8334C1.02454 12.4963 1.01664 12.1955 1.00893 11.9046C1.00174 11.6307 0.994244 11.3475 1.00657 11.052C1.04338 10.2264 1.39539 9.44733 1.98888 8.87778C2.58238 8.30823 3.37132 7.99243 4.19046 7.99652C5.50586 4.96055 8.51104 2.83337 12 2.83337C15.489 2.83337 18.4942 4.96055 19.8096 7.99656C20.6288 7.99185 21.418 8.30738 22.0116 8.87695C22.6052 9.44651 22.9571 10.2259 22.9934 11.0515C23.0058 11.3474 22.9983 11.6306 22.991 11.9045C22.9834 12.1954 22.9755 12.4964 22.9896 12.8337ZM17.5801 11.4265C17.5798 12.2888 17.3831 13.1396 17.0053 13.9132C16.6274 14.6867 16.0785 15.3624 15.4009 15.8882C14.7232 16.4139 13.9349 16.7756 13.0968 16.9453C12.2586 17.1151 11.393 17.0884 10.5667 16.8673L8.30811 18.1831C8.19415 18.2495 8.06323 18.2803 7.93192 18.2716C7.8006 18.263 7.67478 18.2152 7.57037 18.1344C7.46597 18.0536 7.38766 17.9433 7.34537 17.8176C7.30307 17.6919 7.29868 17.5564 7.33275 17.4282L7.90998 15.2559C6.95405 14.2136 6.42216 12.8464 6.42014 11.4265C6.42014 8.32176 8.92314 5.79614 12 5.79614C15.0769 5.79614 17.5801 8.32176 17.5801 11.4265ZM10.4487 11.4265C10.4487 11.2485 10.3786 11.0777 10.2538 10.9519C10.129 10.826 9.95982 10.7553 9.78336 10.7553H9.78225C9.65072 10.7555 9.52221 10.7951 9.41296 10.869C9.30371 10.9429 9.21863 11.0478 9.16846 11.1705C9.11829 11.2931 9.10529 11.4281 9.13111 11.5582C9.15692 11.6883 9.22038 11.8077 9.31348 11.9015C9.40657 11.9952 9.52513 12.059 9.65415 12.0848C9.78318 12.1106 9.91689 12.0972 10.0384 12.0464C10.1599 11.9956 10.2637 11.9096 10.3368 11.7992C10.4098 11.6889 10.4488 11.5592 10.4488 11.4265H10.4487ZM12.6655 11.4265C12.6654 11.4045 12.6642 11.3825 12.6619 11.3607C12.6598 11.3388 12.6566 11.3169 12.6522 11.2954C12.6482 11.2739 12.6429 11.2526 12.6362 11.2318C12.63 11.2108 12.6225 11.1902 12.6145 11.1696C12.6065 11.149 12.5968 11.1298 12.5866 11.1106C12.5764 11.0912 12.5653 11.0724 12.5533 11.0542C12.5412 11.0358 12.5281 11.018 12.5142 11.0009C12.5005 10.9838 12.4859 10.9676 12.4703 10.9522C12.4553 10.9365 12.4388 10.9217 12.422 10.9074C12.4051 10.894 12.3874 10.8806 12.3692 10.8685C12.3511 10.8564 12.3325 10.8452 12.3133 10.8349C12.2942 10.8247 12.2743 10.8153 12.2543 10.8068C12.2343 10.7983 12.2139 10.791 12.1931 10.7848C12.1516 10.7714 12.1088 10.7627 12.0654 10.7589C12.0002 10.7525 11.9345 10.7557 11.8702 10.7683C11.8488 10.7727 11.8277 10.7782 11.8068 10.7848C11.786 10.791 11.7656 10.7983 11.7456 10.8068C11.7257 10.8153 11.7057 10.8247 11.6866 10.8349C11.6676 10.8452 11.6489 10.8564 11.6307 10.8685C11.5943 10.8929 11.5604 10.9209 11.5296 10.9522C11.514 10.9676 11.4994 10.9839 11.4857 11.0009C11.4719 11.018 11.4591 11.0358 11.4471 11.0542C11.4349 11.0724 11.4237 11.0912 11.4134 11.1106C11.4032 11.1297 11.394 11.1495 11.3859 11.1696C11.3774 11.19 11.37 11.2107 11.3637 11.2318C11.3575 11.2524 11.3522 11.2739 11.3478 11.2954C11.3434 11.317 11.3401 11.3388 11.338 11.3607C11.3358 11.3826 11.3349 11.4045 11.3349 11.4265C11.3349 11.4484 11.3358 11.4708 11.338 11.4927C11.3401 11.5145 11.3434 11.5361 11.3478 11.5576C11.3522 11.579 11.3575 11.6005 11.3637 11.6215C11.37 11.6425 11.3774 11.6631 11.3859 11.6833C11.394 11.7036 11.4032 11.7235 11.4134 11.7428C11.4236 11.762 11.4351 11.7808 11.4471 11.7992C11.4591 11.8174 11.4719 11.8351 11.4857 11.852C11.4995 11.8691 11.5142 11.8855 11.5296 11.9012C11.5451 11.9164 11.5611 11.9316 11.5784 11.9455C11.5951 11.9595 11.6125 11.9725 11.6307 11.9844C11.6489 11.9965 11.6675 12.0081 11.6866 12.0184C11.7252 12.0387 11.7654 12.0554 11.8068 12.0685C11.8276 12.0748 11.8489 12.0802 11.8702 12.0846C11.913 12.0935 11.9565 12.0978 12.0002 12.0976C12.1764 12.0971 12.3454 12.0266 12.4703 11.9012C12.501 11.8698 12.5288 11.8357 12.5533 11.7992C12.5653 11.7808 12.5763 11.762 12.5866 11.7428C12.5968 11.7236 12.6061 11.7034 12.6145 11.6833C12.6229 11.6632 12.63 11.6421 12.6362 11.6215C12.6428 11.6006 12.6482 11.5792 12.6522 11.5576C12.6565 11.5361 12.6598 11.5145 12.6619 11.4927C12.6642 11.4707 12.6653 11.4485 12.6653 11.4264L12.6655 11.4265ZM14.8832 11.4265C14.8832 11.2485 14.8131 11.0777 14.6883 10.9519C14.5636 10.826 14.3943 10.7553 14.2179 10.7553H14.2166C14.0851 10.7556 13.9566 10.7951 13.8473 10.869C13.7381 10.9429 13.653 11.0479 13.6028 11.1705C13.5527 11.2932 13.5397 11.4281 13.5655 11.5582C13.5913 11.6883 13.6548 11.8078 13.7479 11.9015C13.841 11.9952 13.9595 12.059 14.0886 12.0848C14.2176 12.1106 14.3513 12.0972 14.4728 12.0464C14.5943 11.9956 14.6981 11.9095 14.7712 11.7992C14.8442 11.6889 14.8832 11.5591 14.8832 11.4265Z" fill="#D71920"/>
              </svg>
              <span class="ml-2">যোগাযোগ</span>
          </div>

          <div
              class="items-center cursor-pointer flex capitalize px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 border-b-1 border-gray-100"
              @click="logOut(); nevigate(); $emit('onClickAccountDropdown');"
          >
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                  <path d="M8.25 9.5V5.75C8.25 5.15326 8.48705 4.58097 8.90901 4.15901C9.33097 3.73705 9.90326 3.5 10.5 3.5H16.5C17.0967 3.5 17.669 3.73705 18.091 4.15901C18.5129 4.58097 18.75 5.15326 18.75 5.75V19.25C18.75 19.8467 18.5129 20.419 18.091 20.841C17.669 21.2629 17.0967 21.5 16.5 21.5H10.5C9.90326 21.5 9.33097 21.2629 8.90901 20.841C8.48705 20.419 8.25 19.8467 8.25 19.25V15.5M5.25 15.5L2.25 12.5M2.25 12.5L5.25 9.5M2.25 12.5H15" stroke="#D71920" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span v-if="!isLoggingOut" class="ml-2">Log out</span>
              <span v-else class="ml-2">Logging out</span>


          </div>

<!--				<p
					class="cursor-pointer block capitalize px-4 py-2 hover:bg-gray-100"
					@click="
						logOut();
						$emit('onClickAccountDropdown');
					"
				>
					<span
						class="text-sm text-gray-700 hover:text-gray-900"
						v-if="!isLoggingOut"
						>Log Out</span
					>
					<span class="text-sm text-gray-700 hover:text-gray-900" v-else
						>Logging Out</span
					>
				</p>-->
			</div>
		</div>
	</div>
	<div
		v-if="showDropdown"
		@click="showDropdown = !showDropdown"
		class="fixed inset-0 bg-black z-40 opacity-0"
	></div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { links } from "@/data/loggedinuserlinks";
import RoundImage from "@/components/atom/RoundImage";
import Form from "@/services/form";
import {clearDeviceInterests} from "@/services/clearDeviceInterests";
export default {
	name: "AccountDropdown",
	emits: ["onClickAccountDropdown"],
	components: {
		RoundImage,
	},

	data() {
		return {
			isLoggingOut: false,
			form: new Form(),
			showDropdown: false,
			links,
		};
	},

	props: {
		userType: { required: false },
	},

	computed: {
		...mapGetters({
			user: "user/getUser",
		}),
	},

	methods: {
		...mapMutations({
			setUserInfo: "user/setLoggedInUser",
		}),

		nevigate() {
			this.showDropdown = false;
		},

		async logOut() {
			localStorage.removeItem("trip_auth_user");
			localStorage.removeItem("token");
			localStorage.removeItem("imp_token");
            clearDeviceInterests();
			this.isLoggingOut = true;
			try {
				await this.form.post("auth/logout");
			} catch (err) {
				if (err.response) {
				}
			} finally {
				this.setUserInfo(null);
				this.$router.push("/signup");
			}
		},
	}, //end of methods

	created() {
		this.setUserInfo();
    console.log(this.user);
	},
};
</script>

<style>
svg.opened {
	transform: rotate(180deg);
	transition: all 300ms ease-in-out;
}
svg.closed {
	transition: all 300ms ease-in-out;
}
</style>
